<a class="nav-link sidebarMenuItem" role="button" (click)="logout()">Log Out</a>
